import { createContext, useContext, useEffect, useState } from "react";
import service1 from './assets/service1.jpeg';
import service2 from './assets/service2.jpeg';
import service3 from './assets/service3.jpeg';
import service4 from './assets/service4.jpeg';

const translations = {
  hy: {
    navigation: {
      home: "Գլխավոր",
      about: "Մեր մասին",
      services: "Ծառայություններ",
      contact: "Կապ",
    },
    accessibility: {
      logo: "Սիվեյ լոգիստիկս ընկերության լոգոտիպ",
      heroImage: "Բեռնատար՝ առաքման երթուղու վրա",
      language: "Ընտրել լեզուն",
      openMenu: "Բացել ընտրացանկը",
      closeMenu: "Փակել ընտրացանկը",
    },
    hero: {
      name: "ՍԻՎԵՅ",
      category: "ԼՈԳԻՍՏԻԿՍ",
      tagline: "Որտեղ հուսալիությունը որակ է։",
    },
    services: {
      title: "Մեր ծառայությունները",
      pageIntro:
        "Լոգիստիկ լուծումներ, որոնք հարմարեցված են ձեր բեռին, ժամկետներին և նպատակակետին։",
      details: "Մանրամասն",
      items: [
        {
          id: "air",
          photo: service1,
          photoPosition: "left",
          name: "Ավիափոխադրումներ",
          info: "Արագ և հուսալի օդային բեռնափոխադրումներ ամբողջ աշխարհում։",
          fullInfo:
            "Եթե փնտրում եք փոխադրման ամենաարագ տարբերակը, Սիվեյ լոգիստիկս ընկերությունն առաջարկում է համախմբված և չարտերային օդային փոխադրումներ աշխարհի ցանկացած կետից դեպի ցանկացած ուղղությամբ։ Աշխարհի առաջատար ցանցերի հետ մեր համագործակցությունը թույլ է տալիս աշխարհագրական սահմանափակումներ չունենալ և առաջարկել հետևյալ ծառայությունները՝",
          features: [
            "Առաքում դռնից դուռ՝ ամբողջ աշխարհում",
            "Մուտքային և ելքային բեռների ամբողջական սպասարկում",
            "Պահեստավորում",
            "Խորհրդատվական ծառայություններ",
            "Փչացող, վտանգավոր և մասնագիտացված բեռների առաքում",
            "Բեռնափոխադրման ապահովագրական փաթեթ",
            "Փաստաթղթերի պատրաստում",
          ],
        },
        {
          id: "sea",
          photo: service2,
          photoPosition: "center",
          name: "Ծովային փոխադրումներ",
          info: "Միջազգային ծովային բեռնափոխադրումներ՝ շահավետ պայմաններով։",
          fullInfo:
            "Եթե փնտրում եք առավել շահավետ գին և չեք շտապում, Սիվեյ լոգիստիկս ընկերությունն առաջարկում է ծովային բեռնափոխադրումների բոլոր տեսակները՝ FCL (ամբողջական կոնտեյներով բեռ) և LCL (մասնակի բեռ), ինչպես նաև հատուկ կոնտեյներներ, օրինակ՝",
          features: [
            "Բաց վերնամասով կոնտեյներ՝ ոչ ստանդարտ բարձրության բեռների համար",
            "Սառնարանային կոնտեյներ՝ ջերմաստիճանի վերահսկմամբ",
            "Flat rack / bulk՝ չափազանց մեծ բեռների համար",
          ],
        },
        {
          id: "ground",
          photo: service3,
          photoPosition: "right",
          name: "Ցամաքային փոխադրումներ",
          info: "Ճկուն ցամաքային բեռնափոխադրումներ Չինաստանից, Եվրոպայից և ԱՊՀ երկրներից։",
          fullInfo:
            "Եթե փնտրում եք օդային փոխադրումից ավելի արագ, բայց միաժամանակ շահավետ գնով տարբերակ, Սիվեյ լոգիստիկս ընկերությունն առաջարկում է ցամաքային փոխադրումներ Չինաստանից, Եվրոպայից և ԱՊՀ երկրներից։ Մեր պահեստները թույլ են տալիս սպասարկել ցանկացած չափի և ծավալի բեռներ։ Մեր ծառայություններն են՝",
          features: [
            "Առաքում դռնից դուռ՝ ամբողջ աշխարհում",
            "Պահեստավորում",
            "Խորհրդատվական ծառայություններ",
            "Փչացող, վտանգավոր և մասնագիտացված բեռների առաքում",
            "Բեռնափոխադրման ապահովագրական փաթեթ",
            "Փաստաթղթերի պատրաստում",
          ],
        },
        {
          id: "car",
          photo: service4,
          photoPosition: "center",
          name: "Ավտոմեքենաների փոխադրում",
          info: "Ավտոմեքենաների ձեռքբերում և փոխադրում ցանկացած կետից։",
          fullInfo:
            "Եթե մեքենա եք փնտրում կամ արդեն գնել եք այն և չգիտեք՝ ինչպես տեղափոխել, Սիվեյ լոգիստիկս ընկերությունն օգնում է մեքենա ձեռք բերել ցանկացած կետից և տեղափոխել այն։",
        },
      ],
    },
    homeHighlights: {
      eyebrow: "Ձեր վստահելի գործընկերը",
      title: "Լոգիստիկա՝ առանց ավելորդ բարդությունների",
      intro:
        "Մենք կազմակերպում ենք բեռնափոխադրումները սկզբից մինչև վերջ՝ օգնելով ձեր բիզնեսին վստահ առաջ շարժվել։",
      items: [
        {
          title: "Հուսալի առաքում",
          info: "Հետևում ենք փոխադրման ընթացքին և պահպանում ենք կապը յուրաքանչյուր փուլում։",
        },
        {
          title: "Ճկուն լուծումներ",
          info: "Ընտրում ենք ձեր բեռին, երթուղուն և ժամանակացույցին համապատասխան տարբերակ։",
        },
        {
          title: "Միջազգային ծածկույթ",
          info: "Համակարգում ենք օդային, ծովային և ցամաքային բեռնափոխադրումներ։",
        },
      ],
      cta: "Դիտել ծառայությունները",
    },
    about: {
      companyName: "Սիվեյ լոգիստիկս ընկերություն",
      heroTitle: "Օգնում ենք բիզնեսին առաջ շարժվել",
      heroDescription:
        "Մենք կապում ենք բիզնեսները աշխարհի հետ՝ հուսալի լոգիստիկ և փոխադրումների լուծումներով։",
      storyImage: "Լոգիստիկա և միջազգային փոխադրումներ",
      storyEyebrow: "Ով ենք մենք",
      storyTitle: "Լոգիստիկա՝ ձեր բիզնեսի կարիքներին համապատասխան",
      storyParagraph1:
        "Մենք օգնում ենք բիզնեսներին արդյունավետ տեղափոխել ապրանքները՝ համակարգելով փոխադրումները, կառավարելով լոգիստիկ գործընթացները և կապելով մատակարարման շղթայի տարբեր փուլերը։",
      storyParagraph2:
        "Մեր աշխատանքը հիմնված է հստակ հաղորդակցության, ուշադիր համակարգման և յուրաքանչյուր բեռի կարիքներին համապատասխան լուծումների վրա։",
      missionTitle: "Մեր առաքելությունը",
      missionText:
        "Մեր հաճախորդների համար լոգիստիկան դարձնել ավելի պարզ, թափանցիկ և հուսալի։",
      companyDescription:
        "Սիվեյ լոգիստիկս ընկերությունը 2022 թվականից գործող միջազգային բեռնափոխադրող ընկերություն է։ Մենք կազմակերպում ենք ցանկացած տեսակի բեռների ծովային, օդային և ցամաքային փոխադրումներ՝ առանց սահմանափակումների։ Մեր պրոֆեսիոնալ թիմի, տարիների փորձի, գործարար կապերի և գործընկերների շնորհիվ առաջարկում ենք հուսալի գործընկերային ցանց։",
      companyGoal:
        "Մեր նպատակն է մատուցել որակյալ, արագ, հարմարավետ և հուսալի ծառայություն։",
      advantagesEyebrow: "Ինչու ընտրել մեզ",
      advantagesTitle: "Մեր մոտեցման առավելությունները",
      advantagesIntro:
        "Մենք ուշադրություն ենք դարձնում այն մանրամասներին, որոնք օգնում են բիզնեսներին ավելի արդյունավետ կազմակերպել փոխադրումները։",
      advantages: [
        {
          title: "Հուսալի համակարգում",
          description:
            "Փոխադրումների և լոգիստիկ գործընթացների ուշադիր համակարգում յուրաքանչյուր փուլում։",
        },
        {
          title: "Ճկուն լուծումներ",
          description:
            "Փոխադրման լուծումներ՝ հարմարեցված բեռի և բիզնեսի կարիքներին։",
        },
        {
          title: "Հստակ հաղորդակցություն",
          description:
            "Թափանցիկ հաղորդակցություն և ժամանակին թարմացումներ լոգիստիկ գործընթացի ընթացքում։",
        },
        {
          title: "Բիզնեսի կարիքներին ուղղված ծառայություն",
          description:
            "Գործնական մոտեցում՝ ձեր գործառնական պահանջներին և առաքման նպատակներին համապատասխան։",
        },
      ],
      processEyebrow: "Ինչպես ենք աշխատում",
      processTitle: "Պլանավորումից մինչև առաքում",
      processIntro:
        "Կազմակերպված մոտեցումն օգնում է լոգիստիկ գործընթացները պահել հստակ և համակարգված։",
      processSteps: [
        {
          title: "Հասկանում ենք ձեր կարիքները",
          description:
            "Ծանոթանում ենք բեռին, նպատակակետին, ժամկետներին և հատուկ պահանջներին։",
        },
        {
          title: "Պլանավորում ենք փոխադրումը",
          description:
            "Ձեր պահանջների հիման վրա ընտրում ենք փոխադրման համապատասխան տարբերակը։",
        },
        {
          title: "Համակարգում ենք գործընթացը",
          description:
            "Կազմակերպում ենք լոգիստիկ գործընթացը և կապի մեջ մնում ձեզ հետ։",
        },
        {
          title: "Ավարտում ենք առաքումը",
          description:
            "Աշխատում ենք փոխադրումն ավարտել համաձայնեցված պլանի համաձայն։",
        },
      ],
    },
    contact: {
      companyName: "Սիվեյ լոգիստիկս ընկերություն",
      heroTitle: "Օգնենք ձեր բիզնեսին առաջ շարժվել",
      heroDescription:
        "Ունե՞ք կազմակերպելու բեռ կամ հարց մեր լոգիստիկ ծառայությունների մասին։ Կապվեք մեր թիմի հետ՝ ձեր պահանջները քննարկելու համար։",
      phone: "Հեռախոս",
      phoneDescription: "Կապվեք մեզ հետ հեռախոսով",
      email: "Էլ․ փոստ",
      emailDescription: "Ուղարկեք մեզ ձեր հարցումը",
      location: "Գտնվելու վայր",
      locationDescription: "Մեր գրասենյակի հասցեն",
      address: "75 Mantashyan st., Yerevan, Armenia",
      country: "Հայաստան",
      formEyebrow: "Կապվեք մեզ հետ",
      formTitle: "Ուղարկեք մեզ հաղորդագրություն",
      formDescription:
        "Ներկայացրեք ձեր փոխադրման պահանջները, որպեսզի կարողանանք քննարկել ձեր հարցումը։",
      name: "Անուն, ազգանուն",
      namePlaceholder: "Ձեր անունը",
      emailAddress: "Էլ․ փոստի հասցե",
      emailPlaceholder: "you@example.com",
      phoneNumber: "Հեռախոսահամար",
      service: "Ծառայություն",
      selectService: "Ընտրեք ծառայությունը",
      seaFreight: "Ծովային փոխադրումներ",
      airFreight: "Ավիափոխադրումներ",
      groundFreight: "Ցամաքային փոխադրումներ",
      otherInquiry: "Այլ հարցում",
      message: "Ձեր հաղորդագրությունը",
      messagePlaceholder: "Պատմեք մեզ ձեր բեռի մասին…",
      sendMessage: "Ուղարկել հաղորդագրությունը",
      formPending:
        "Հայտը պատրաստ է backend-ին միացնելու համար։ Հաղորդագրությունը դեռ չի ուղարկվել։",
      mapTitle: "Գտեք մեր գտնվելու վայրը",
      mapDescription:
        "Մեր ծառայությունների և գործունեության վայրերի մասին ավելին իմանալու համար կապվեք մեզ հետ։",
      mapPlaceholder: "75 Mantashyan st., Yerevan, Armenia",
    },
    partners: {
      eyebrow: "Մեր գործընկերները",
      heading: "Ուժեղ համագործակցություն",
      headingAccent: "Ավելի լավ լոգիստիկա։",
      intro:
        "Համագործակցությունը արդյունավետ լոգիստիկայի հիմքն է։ Ծանոթացեք այն ցանցերին և գործընկերություններին, որոնք կապում են բիզնեսները, ուղղություններն ու հնարավորությունները։",
      previous: "Նախորդ գործընկերը",
      next: "Հաջորդ գործընկերը",
      overview: "Գործընկերության ակնարկ",
      overviewTitle: "Բիզնեսների կապը՝ հուսալի լոգիստիկ ցանցերի միջոցով։",
      partnership: "Գործընկերություն",
      network: "Համաշխարհային լոգիստիկ ցանց",
      categoryLabel: "Լոգիստիկա և փոխադրումներ",
      showPartner: "Ցուցադրել գործընկեր",
      items: [
        {
          id: 1,
          name: "Համաշխարհային բեռնափոխադրումների ցանց",
          category: "ՄԻՋԱԶԳԱՅԻՆ ԲԵՌՆԱՓՈԽԱԴՐՈՒՄՆԵՐ",
          description:
            "Մեր միջազգային բեռնափոխադրումների գործընկերներն օգնում են բիզնեսներին կապվել աշխարհի շուկաների հետ։ Տրանսպորտային լայն ցանցի և համակարգված լոգիստիկ գործառնությունների միջոցով աջակցում ենք բեռների տեղափոխմանը միջազգային սահմաններով։ Նախնական պլանավորումից մինչև վերջնական առաքում՝ մեր գործընկերությունները նպաստում են արդյունավետ գործընթացներին, համակարգմանը և բեռի տարբեր պահանջներին համապատասխան ճկուն լուծումներին։",
        },
        {
          id: 2,
          name: "Օդային բեռնափոխադրումների դաշինք",
          category: "ՕԴԱՅԻՆ ՓՈԽԱԴՐՈՒՄՆԵՐԻ ԼՈՒԾՈՒՄՆԵՐ",
          description:
            "Մեր օդային բեռնափոխադրումների ցանցն աջակցում է այն բիզնեսներին, որոնց անհրաժեշտ են արագ և ուշադիր համակարգված փոխադրումներ։ Օդային բեռնափոխադրումների գործընկերների հետ համագործակցությունը թույլ է տալիս պլանավորել միջազգային առաքումները, համաձայնեցնել փոխադրման ժամանակացույցերը և աջակցել ժամկետային առաքումներին։ Ընտրում ենք հարմար երթուղիներ՝ հաշվի առնելով նպատակակետը, բեռի առանձնահատկություններն ու առաքման պահանջները։",
        },
        {
          id: 3,
          name: "Եվրոպական տրանսպորտային ցանց",
          category: "ՃԱՆԱՊԱՐՀԱՅԻՆ ՓՈԽԱԴՐՈՒՄՆԵՐ",
          description:
            "Հուսալի ճանապարհային փոխադրումները կապում են պահեստները, բաշխման կենտրոնները, նավահանգիստներն ու վերջնական նպատակակետերը։ Մեր ճանապարհային ցանցն աջակցում է տարածաշրջանային և միջազգային բեռնափոխադրումներին՝ ճկուն երթուղիներով և համակարգված առաքման պլանավորմամբ։ Տրանսպորտային մատակարարների հետ համագործակցելով՝ ձգտում ենք պարզեցնել լոգիստիկ գործառնությունները և արդյունավետ տեղափոխել բեռները կարևոր առևտրային կենտրոնների միջև։",
        },
      ],
    },
    footer: {
      description:
        "Հուսալի լոգիստիկ լուծումներ, որոնք բիզնեսները կապում են աշխարհի հետ՝ արդյունավետ և ճկուն փոխադրումների միջոցով։",
      quickLinks: "Արագ հղումներ",
      ourServices: "Մեր ծառայությունները",
      getInTouch: "Կապվեք մեզ հետ",
      location: "Գտնվելու վայր",
      email: "Էլ․ փոստ",
      phone: "Հեռախոս",
      rights: "Բոլոր իրավունքները պաշտպանված են։",
      createdBy: "Կայքը ստեղծվել է",
      createdBySuffix: "ծրագրավորման կենտրոնի կողմից։",
    },
    serviceDetails: {
      notFoundLabel: "404 — Չի գտնվել",
      notFoundTitle: "Ծառայությունը չի գտնվել",
      notFoundMessage:
        "Հնարավոր է՝ էջը տեղափոխվել է, կամ հասցեն սխալ է նշված։",
      returnHome: "Վերադառնալ ծառայությունների էջ",
      home: "Ծառայություններ",
      sectionTitle: "Մեր ծառայությունները",
      moreInfo: "Մանրամասն տեղեկություն",
      infoLabel: "Տեղեկություն",
      infoHeading: "Այն ամենը, ինչ պետք է իմանալ",
      infoHeadingAccent: "ծառայության մասին",
      infoIntro:
        "Ծանոթացեք մանրամասներին և իմացեք ավելին մեր առաջարկած ծառայության մասին։",
      serviceLabel: "Ծառայություն",
      infoComingSoon: "Ծառայության մասին տեղեկությունը շուտով կհայտնվի։",
      qualityTagline: "Որակ · Հուսալիություն · Արդյունք",
      questions: "Հարցե՞ր ունեք",
      discussProject: "Եկեք քննարկենք ձեր նախագիծը",
      contactDescription:
        "Մանրամասներին ծանոթանալու և ձեզ հարմար լուծումը քննարկելու համար կապվեք մեզ հետ։",
      contactUs: "Կապվել մեզ հետ",
    },
  },
  ru: {
    navigation: {
      home: "Главная",
      about: "О нас",
      services: "Услуги",
      contact: "Контакты",
    },
    accessibility: {
      logo: "Логотип компании «Сивей Логистикс»",
      heroImage: "Грузовой транспорт на маршруте доставки",
      language: "Выбрать язык",
      openMenu: "Открыть меню",
      closeMenu: "Закрыть меню",
    },
    hero: {
      name: "СИВЕЙ",
      category: "ЛОГИСТИКА",
      tagline: "Надёжность — это качество.",
    },
   services: {
  title: "Наши услуги",
  pageIntro:
    "Логистические решения с учетом типа вашего груза, сроков доставки и пункта назначения.",
  details: "Подробнее",
  items: [
    {
      id: "air",
      photo: service1,
      photoPosition: "left",
      name: "Авиаперевозки",
      info:
        "Быстрая и надежная доставка грузов воздушным транспортом по всему миру.",
      fullInfo:
        "Компания «Сивей Логистикс» организует регулярные и чартерные авиаперевозки из любой точки мира в любую точку назначения. Благодаря сотрудничеству с ведущими международными логистическими сетями мы предлагаем широкий спектр услуг: доставку от двери до двери, обработку входящих и исходящих грузов, складское хранение, консультации, перевозку скоропортящихся, опасных и специализированных грузов, страхование перевозок и подготовку документов.",
      features: [
        "Доставка от двери до двери по всему миру",
        "Обработка входящих и исходящих грузов",
        "Складское хранение",
        "Консультационные услуги",
        "Перевозка скоропортящихся, опасных и специализированных грузов",
        "Страхование грузоперевозок",
        "Подготовка документов",
      ],
    },
    {
      id: "sea",
      photo: service2,
      photoPosition: "center",
      name: "Морские перевозки",
      info:
        "Экономически выгодная доставка грузов морским транспортом по международным маршрутам.",
      fullInfo:
        "Если для вас важнее оптимальная стоимость, чем скорость доставки, компания «Сивей Логистикс» предлагает все основные виды морских перевозок: FCL — перевозка полной контейнерной загрузки и LCL — перевозка сборных грузов. Также доступны специальные контейнеры для нестандартных и крупногабаритных грузов.",
      features: [
        "FCL — перевозка полных контейнеров",
        "LCL — перевозка сборных грузов",
        "Open Top — контейнеры с открытым верхом для высоких грузов",
        "Reefer — рефрижераторные контейнеры с контролем температуры",
        "Flat Rack / Bulk — решения для негабаритных грузов",
      ],
    },
    {
      id: "ground",
      photo: service3,
      photoPosition: "right",
      name: "Наземные перевозки",
      info:
        "Гибкая и надежная доставка грузов автомобильным транспортом из Китая, Европы и стран СНГ.",
      fullInfo:
        "Компания «Сивей Логистикс» организует наземные грузоперевозки из Китая, Европы и стран СНГ. Это оптимальный вариант для тех, кому нужна более быстрая доставка по сравнению с морскими перевозками при сохранении разумной стоимости. Наши складские возможности помогают организовать обработку и перевозку грузов различного объема.",
      features: [
        "Доставка от двери до двери",
        "Складское хранение",
        "Консультационные услуги",
        "Перевозка скоропортящихся, опасных и специализированных грузов",
        "Страхование грузоперевозок",
        "Подготовка документов",
      ],
    },
    {
      id: "car",
      photo: service4,
      photoPosition: "center",
      name: "Перевозка автомобилей",
      info:
        "Помощь в приобретении и доставке автомобилей из любой точки.",
      fullInfo:
        "Компания «Сивей Логистикс» помогает приобрести автомобиль в любой точке и организует его доставку. Мы помогаем подобрать автомобиль и доставить его откуда угодно.",
      features: [
        "Помощь в приобретении автомобилей в любой точке",
        "Организация транспортировки автомобилей",
      ],
    },
  ],
},
    homeHighlights: {
      eyebrow: "Ваш надёжный партнёр",
      title: "Логистика без лишних сложностей",
      intro:
        "Организуем перевозку груза от начала до конца, чтобы ваш бизнес мог уверенно двигаться вперёд.",
      items: [
        {
          title: "Надёжная доставка",
          info: "Контролируем ход перевозки и остаёмся на связи на каждом этапе.",
        },
        {
          title: "Гибкие решения",
          info: "Подбираем вариант с учётом груза, маршрута и сроков.",
        },
        {
          title: "Международное покрытие",
          info: "Координируем воздушные, морские и наземные перевозки.",
        },
      ],
      cta: "Посмотреть услуги",
    },
    about: {
      companyName: "Компания «Сивей Логистикс»",
      heroTitle: "Помогаем бизнесу двигаться вперёд",
      heroDescription:
        "Мы связываем бизнес с миром с помощью надёжных логистических и транспортных решений.",
      storyImage: "Логистика и международные перевозки",
      storyEyebrow: "Кто мы",
      storyTitle: "Логистика с учётом потребностей вашего бизнеса",
      storyParagraph1:
        "Мы помогаем компаниям эффективно перемещать товары: координируем перевозки, управляем логистическими процессами и связываем разные этапы цепочки поставок.",
      storyParagraph2:
        "В основе нашего подхода — понятная коммуникация, внимательная координация и решения с учётом потребностей каждого груза.",
      missionTitle: "Наша миссия",
      missionText:
        "Делать логистику проще, прозрачнее и надёжнее для наших клиентов.",
      companyDescription:
        "Компания «Сивей Логистикс» — международная транспортно-экспедиторская компания, работающая с 2022 года. Мы организуем перевозку любых видов грузов морским, воздушным и наземным транспортом без ограничений. Благодаря профессиональной команде, многолетнему опыту, деловым связям и партнёрам компания располагает надёжной партнёрской сетью.",
      companyGoal:
        "Наша цель — предлагать качественный, быстрый, удобный и надёжный сервис.",
      advantagesEyebrow: "Почему выбирают нас",
      advantagesTitle: "Чем отличается наш подход",
      advantagesIntro:
        "Мы уделяем внимание деталям, которые помогают бизнесу эффективнее организовать перевозки.",
      advantages: [
        {
          title: "Надёжная координация",
          description:
            "Тщательно координируем перевозки и логистические процессы на каждом этапе.",
        },
        {
          title: "Гибкие решения",
          description:
            "Подбираем перевозку с учётом требований к грузу и потребностей бизнеса.",
        },
        {
          title: "Понятная коммуникация",
          description:
            "Обеспечиваем прозрачное общение и своевременные обновления на протяжении перевозки.",
        },
        {
          title: "Сервис для вашего бизнеса",
          description:
            "Предлагаем практичный подход с учётом рабочих задач и целей доставки.",
        },
      ],
      processEyebrow: "Как мы работаем",
      processTitle: "От планирования до доставки",
      processIntro:
        "Чёткий подход помогает поддерживать порядок и ясность в логистических процессах.",
      processSteps: [
        {
          title: "Изучаем ваши потребности",
          description:
            "Уточняем информацию о грузе, пункте назначения, сроках и особых требованиях.",
        },
        {
          title: "Планируем перевозку",
          description:
            "Подбираем подходящий способ перевозки с учётом ваших требований.",
        },
        {
          title: "Координируем процесс",
          description:
            "Организуем логистический процесс и остаёмся с вами на связи.",
        },
        {
          title: "Завершаем доставку",
          description:
            "Стремимся выполнить перевозку в соответствии с согласованным планом.",
        },
      ],
    },
    contact: {
      companyName: "Компания «Сивей Логистикс»",
      heroTitle: "Поможем вашему бизнесу двигаться вперёд",
      heroDescription:
        "Нужно организовать перевозку или есть вопросы о наших логистических услугах? Свяжитесь с нашей командой, чтобы обсудить ваши требования.",
      phone: "Телефон",
      phoneDescription: "Позвоните нам",
      email: "Электронная почта",
      emailDescription: "Отправьте нам запрос",
      location: "Местоположение",
      locationDescription: "Адрес нашего офиса",
      address: "75 Mantashyan st., Yerevan, Armenia",
      country: "Армения",
      formEyebrow: "Свяжитесь с нами",
      formTitle: "Отправьте нам сообщение",
      formDescription:
        "Расскажите о ваших требованиях к перевозке, чтобы мы могли обсудить ваш запрос.",
      name: "Имя и фамилия",
      namePlaceholder: "Ваше имя",
      emailAddress: "Электронная почта",
      emailPlaceholder: "you@example.com",
      phoneNumber: "Номер телефона",
      service: "Услуга",
      selectService: "Выберите услугу",
      seaFreight: "Морские перевозки",
      airFreight: "Авиаперевозки",
      groundFreight: "Наземные перевозки",
      otherInquiry: "Другой вопрос",
      message: "Ваше сообщение",
      messagePlaceholder: "Расскажите о вашем грузе…",
      sendMessage: "Отправить сообщение",
      formPending:
        "Форма готова к подключению backend. Сообщение пока не отправлено.",
      mapTitle: "Как нас найти",
      mapDescription:
        "Свяжитесь с нами, чтобы узнать больше об услугах и регионах нашей работы.",
      mapPlaceholder: "75 Mantashyan st., Yerevan, Armenia",
    },
    partners: {
      eyebrow: "Наши партнёры",
      heading: "Сильное партнёрство.",
      headingAccent: "Эффективная логистика.",
      intro:
        "Сотрудничество — основа эффективной логистики. Познакомьтесь с сетями и партнёрами, которые помогают связывать компании, направления и возможности.",
      previous: "Предыдущий партнёр",
      next: "Следующий партнёр",
      overview: "О партнёрстве",
      overviewTitle: "Связываем бизнес с помощью надёжных логистических сетей.",
      partnership: "Партнёрство",
      network: "Глобальная логистическая сеть",
      categoryLabel: "Логистика и перевозки",
      showPartner: "Показать партнёра",
      items: [
        {
          id: 1,
          name: "Глобальная сеть грузоперевозок",
          category: "МЕЖДУНАРОДНЫЕ ПЕРЕВОЗКИ",
          description:
            "Наши международные партнёры помогают связывать бизнес с рынками по всему миру. Благодаря широкой транспортной сети и скоординированным логистическим операциям мы поддерживаем перевозку грузов через международные границы. От начального планирования до конечной доставки партнёрство помогает повышать эффективность, улучшать координацию и предлагать гибкие решения для разных типов грузов.",
        },
        {
          id: 2,
          name: "Альянс авиаперевозок",
          category: "РЕШЕНИЯ ДЛЯ АВИАПЕРЕВОЗОК",
          description:
            "Наша сеть авиаперевозок помогает компаниям, которым нужны быстрые и тщательно скоординированные перевозки. Сотрудничество с партнёрами позволяет планировать международные отправления, согласовывать расписание и поддерживать срочную доставку. Мы подбираем маршруты с учётом направления, особенностей груза и требований к срокам.",
        },
        {
          id: 3,
          name: "Европейская транспортная сеть",
          category: "АВТОМОБИЛЬНЫЕ ПЕРЕВОЗКИ",
          description:
            "Надёжные автомобильные перевозки связывают склады, распределительные центры, порты и конечные пункты назначения. Наша сеть поддерживает региональные и международные перевозки благодаря гибким маршрутам и согласованному планированию доставки. Вместе с транспортными партнёрами мы стремимся упростить логистику и эффективно перемещать грузы между ключевыми торговыми центрами.",
        },
      ],
    },
    footer: {
      description:
        "Надёжные логистические решения, которые связывают бизнес с миром благодаря эффективным и гибким перевозкам.",
      quickLinks: "Быстрые ссылки",
      ourServices: "Наши услуги",
      getInTouch: "Свяжитесь с нами",
      location: "Местоположение",
      email: "Электронная почта",
      phone: "Телефон",
      rights: "Все права защищены.",
      createdBy: "Сайт создан",
      createdBySuffix: "центром программирования.",
    },
    serviceDetails: {
      notFoundLabel: "404 — Не найдено",
      notFoundTitle: "Услуга не найдена",
      notFoundMessage:
        "Возможно, страница была перемещена или адрес указан неверно.",
      returnHome: "Вернуться к услугам",
      home: "К услугам",
      sectionTitle: "Наши услуги",
      moreInfo: "Подробная информация",
      infoLabel: "Информация",
      infoHeading: "Всё, что нужно знать",
      infoHeadingAccent: "об услуге",
      infoIntro:
        "Изучите подробности и узнайте больше о том, что мы предлагаем.",
      serviceLabel: "Услуга",
      infoComingSoon: "Информация об услуге скоро появится.",
      qualityTagline: "Качество · Надёжность · Результат",
      questions: "Есть вопросы?",
      discussProject: "Давайте обсудим ваш проект",
      contactDescription:
        "Свяжитесь с нами, чтобы узнать подробности и обсудить подходящее решение.",
      contactUs: "Связаться с нами",
    },
  },
  en: {
    navigation: {
      home: "Home",
      about: "About us",
      services: "Services",
      contact: "Contact",
    },
    accessibility: {
      logo: "Seaway Logistics logo",
      heroImage: "Freight truck on a delivery route",
      language: "Select language",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      name: "SEAWAY",
      category: "LOGISTICS",
      tagline: "Where reliability is quality.",
    },
    services: {
  title: "Our services",
  pageIntro:
    "Seaway Logistics provides reliable air, sea, and land freight solutions, as well as car transportation from China, tailored to your cargo, schedule, and destination.",
  details: "Learn more",

  items: [
    {
      id: "air",
      photo: service1,
      photoPosition: "left",
      name: "Air freight",
      info:
        "Fast and reliable air freight services worldwide, including consolidated and charter shipments.",
      fullInfo:
        "If you are looking for the fastest shipping option, Seaway Logistics LLC offers consolidated and charter air transportation from anywhere to anywhere. Our partnerships with leading global networks allow us to provide the following services without geographical limits:",
      features: [
        "Door-to-door delivery worldwide",
        "Full inbound/outbound services",
        "Warehousing",
        "Consulting services",
        "Perishable, dangerous, and specialized cargo delivery",
        "Transportation insurance package",
        "Document preparation",
      ],
    },

    {
      id: "sea",
      photo: service2,
      photoPosition: "center",
      name: "Sea freight",
      info:
        "Cost-effective international sea freight for full containers, partial loads, and specialized cargo.",
      fullInfo:
        "If you are looking for the most competitive price and are not in a rush, Seaway Logistics LLC offers all types of sea freight shipping: FCL (Full Container Load) and LCL (Less than Container Load), including special containers such as:",
      features: [
        "Open-top container (for non-standard high loads)",
        "Refrigerated container (temperature-controlled)",
        "Flat-rack / bulk (for oversized cargo)",
      ],
    },

    {
      id: "ground",
      photo: service3,
      photoPosition: "right",
      name: "Land service",
      info:
        "Flexible road freight solutions from China, Europe, and CIS countries.",
      fullInfo:
        "If you are looking for a faster option than air freight at an optimal price, Seaway Logistics LLC offers land transportation from China, Europe, and CIS countries. Our warehouses help us handle shipments of any size and volume. Our services include:",
      features: [
        "Door-to-door delivery worldwide",
        "Warehousing",
        "Consulting services",
        "Perishable, dangerous, and specialized cargo delivery",
        "Transportation insurance package",
        "Document preparation",
      ],
    },

    {
      id: "car",
      photo: service4,
      photoPosition: "center",
      name: "Car transportation",
      info:
        "Car sourcing and transportation services from anywhere.",
      fullInfo:
        "If you are looking for a car or have already bought one and are unsure how to ship it, Seaway Logistics LLC can source and transport cars from anywhere.",
    },
  ],
},
    homeHighlights: {
      eyebrow: "Your trusted logistics partner",
      title: "Logistics without the complexity",
      intro:
        "We coordinate shipments from start to finish, helping your business move forward with confidence.",
      items: [
        {
          title: "Reliable delivery",
          info: "We track your shipment and keep you informed at every stage.",
        },
        {
          title: "Flexible solutions",
          info: "We find an option that fits your cargo, route, and schedule.",
        },
        {
          title: "Global reach",
          info: "We coordinate air, sea, and ground freight transportation.",
        },
      ],
      cta: "Explore our services",
    },
    about: {
      companyName: "Seaway Logistics LLC",
      heroTitle: "Moving business forward",
      heroDescription:
        "We connect businesses to the world through reliable logistics and transportation solutions.",
      storyImage: "Logistics and international transportation",
      storyEyebrow: "Who we are",
      storyTitle: "Logistics built around your business",
      storyParagraph1:
        "We help businesses move goods efficiently by coordinating transportation, managing logistics processes, and connecting different stages of the supply chain.",
      storyParagraph2:
        "Our approach focuses on clear communication, careful coordination, and solutions tailored to the needs of each shipment.",
      missionTitle: "Our mission",
      missionText:
        "To make logistics simpler, more transparent, and more dependable for our clients.",
      companyDescription:
        "Seaway Logistics LLC is an international freight forwarding company based since 2022. We arrange the transportation of all types of cargo by sea, air, and land, without limits. With a professional team, years of experience, business connections, and trusted partners, we provide a reliable partner network.",
      companyGoal:
        "Our goal is to provide quality, fast, convenient, and reliable service.",
      advantagesEyebrow: "Why choose us",
      advantagesTitle: "What makes our approach different",
      advantagesIntro:
        "We focus on the details that help businesses manage transportation more effectively.",
      advantages: [
        {
          title: "Reliable coordination",
          description:
            "Careful coordination of transportation and logistics processes at every stage.",
        },
        {
          title: "Flexible solutions",
          description:
            "Transportation solutions adapted to shipment requirements and business needs.",
        },
        {
          title: "Clear communication",
          description:
            "Transparent communication and timely updates throughout the logistics process.",
        },
        {
          title: "Business-focused service",
          description:
            "A practical approach focused on your operational requirements and delivery goals.",
        },
      ],
      processEyebrow: "How we work",
      processTitle: "From planning to delivery",
      processIntro:
        "A structured approach helps keep logistics processes clear and organized.",
      processSteps: [
        {
          title: "Understand your needs",
          description:
            "We learn about your shipment, destination, timeline, and specific requirements.",
        },
        {
          title: "Plan the transportation",
          description:
            "We identify a suitable transportation approach based on your requirements.",
        },
        {
          title: "Coordinate the process",
          description:
            "We coordinate the logistics process and maintain communication with you.",
        },
        {
          title: "Complete the delivery",
          description:
            "We work toward completing the transportation according to the agreed plan.",
        },
      ],
    },
    contact: {
       companyName: "Seaway Logistics LLC",
      heroTitle: "Let's move your business forward",
      heroDescription:
        "Have a shipment to arrange or a question about our logistics services? Contact our team to discuss your requirements.",
      phone: "Phone",
      phoneDescription: "Contact us by phone",
      email: "Email",
      emailDescription: "Send us your inquiry",
      location: "Location",
      locationDescription: "Our office location",
      address: "75 Mantashyan st., Yerevan, Armenia",
      country: "Armenia",
      formEyebrow: "Get in touch",
      formTitle: "Send us a message",
      formDescription:
        "Tell us about your transportation requirements and we'll have the information needed to discuss your request.",
      name: "Full name",
      namePlaceholder: "Your name",
      emailAddress: "Email address",
      emailPlaceholder: "you@example.com",
      phoneNumber: "Phone number",
      service: "Service",
      selectService: "Select a service",
      seaFreight: "Sea freight",
      airFreight: "Air freight",
      groundFreight: "Ground transportation",
      otherInquiry: "Other inquiry",
      message: "Your message",
      messagePlaceholder: "Tell us about your shipment...",
      sendMessage: "Send message",
      formPending:
        "The form is ready for backend integration. No message has been sent yet.",
      mapTitle: "Find our location",
      mapDescription:
        "Contact us to learn more about our services and operating locations.",
      mapPlaceholder: "75 Mantashyan st., Yerevan, Armenia",
    },
    partners: {
      eyebrow: "Our partners",
      heading: "Strong partnerships.",
      headingAccent: "Better logistics.",
      intro:
        "Collaboration is at the heart of effective logistics. Discover the networks and partnerships that help connect businesses, destinations, and opportunities.",
      previous: "Previous partner",
      next: "Next partner",
      overview: "Partnership overview",
      overviewTitle: "Connecting businesses through reliable logistics networks.",
      partnership: "Partnership",
      network: "Global logistics network",
      categoryLabel: "Logistics & transportation",
      showPartner: "Show partner",
      items: [
        {
          id: 1,
          name: "Global Shipping Network",
          category: "INTERNATIONAL SHIPPING",
          description:
            "Our international shipping partners help us connect businesses to markets around the world. Through an extensive transportation network and coordinated logistics operations, we support the movement of cargo across international borders. From initial planning to final delivery, our partnerships help maintain efficient shipping processes, improve coordination, and provide flexible solutions for different cargo requirements.",
        },
        {
          id: 2,
          name: "Air Cargo Alliance",
          category: "AIR FREIGHT SOLUTIONS",
          description:
            "Our air freight network supports businesses that require fast and carefully coordinated cargo transportation. Working with air cargo partners allows us to plan international shipments, coordinate transportation schedules, and support time-sensitive deliveries. We focus on suitable routes and organize each shipment according to its destination, cargo characteristics, and delivery requirements.",
        },
        {
          id: 3,
          name: "European Transport Network",
          category: "ROAD TRANSPORTATION",
          description:
            "Reliable road transportation connects warehouses, distribution centers, ports, and final destinations. Our network supports regional and international freight movements with flexible routing and coordinated delivery planning. By working with transportation providers, we aim to simplify logistics operations and move cargo efficiently between key commercial locations.",
        },
      ],
    },
    footer: {
      description:
        "Reliable logistics solutions connecting businesses to the world through efficient and flexible freight transportation.",
      quickLinks: "Quick links",
      ourServices: "Our services",
      getInTouch: "Get in touch",
      location: "Location",
      email: "Email",
      phone: "Phone",
      rights: "All rights reserved.",
      createdBy: "Website created by",
      createdBySuffix: ".",
    },
    serviceDetails: {
      notFoundLabel: "404 — Not Found",
      notFoundTitle: "Service not found",
      notFoundMessage:
        "The page may have been moved, or the address may be incorrect.",
      returnHome: "Return to services",
      home: "Go to services",
      sectionTitle: "Our services",
      moreInfo: "Detailed information",
      infoLabel: "Information",
      infoHeading: "Everything you need to know",
      infoHeadingAccent: "about the service",
      infoIntro: "Explore the details and learn more about what we offer.",
      serviceLabel: "Service",
      infoComingSoon: "Information about this service is coming soon.",
      qualityTagline: "Quality · Reliability · Results",
      questions: "Have questions?",
      discussProject: "Let's discuss your project",
      contactDescription:
        "Contact us to learn more and discuss a solution that works for you.",
      contactUs: "Contact us",
    },
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [language, setLanguage] = useState("hy");

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const translation = key
      .split(".")
      .reduce((value, part) => value?.[part], translations[language]);

    if (typeof translation !== "string") {
      throw new Error(`Missing "${key}" translation for language "${language}"`);
    }

    return translation;
  };

  return (
    <I18nContext.Provider
      value={{
        language,
        setLanguage,
        t,
        services: translations[language].services,
        homeHighlights: translations[language].homeHighlights,
        about: translations[language].about,
        contact: translations[language].contact,
        partners: translations[language].partners,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);

  if (!context) {
    throw new Error("useI18n must be used within an I18nProvider");
  }

  return context;
};
